import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "type"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", {
    id: _ctx.containerId,
    type: _ctx.type,
    class: _normalizeClass(_ctx.cssClass)
  }, null, 10 /* CLASS, PROPS */, _hoisted_1))
}